import { Communicator } from "./databin$"
import { CoordinatorService } from "./coordinator.service"
import { BehaviorSubject, Subject } from "rxjs"
import { XItem } from "./x-item"

export class ClipboardCommunicator implements Communicator {
    tag = "clipboard"
    update$ = new Subject<void>()
    itmLs: Object[] = []
    text$ = new BehaviorSubject<string>("")
    // buttonCommunicator$ = new Subject()


    constructor(public coords: CoordinatorService) {
        // this.coords.worker$.parser.response$.subscribe(x => {
        //     if (this.connection?.connector.tag !== 'clipboard')
        //         return
        //     if (x.action !== "connection" ||
        //         x.payload.connectionId !== this.connection?.id) return

        //     this.connection.set("_hits", x.payload.resp.xitemCount)
        //     this.coords.databin$.communicatorStage$.next(2)
        // })
    }

    get connection() {
        return this.coords.databin$.editedConnection$.getValue()!
    }

    get source() {
        return this.coords.text("Clipboard")
    }

    setHelpId() {
        this.coords.display$.lastDialogAction = "parse-clipboard"
    }

    async parseClipboard() {
        const pf = this.coords.databin$.createParserFile({
            connection: this.connection,
            rawText: this.text$.getValue()
        })
        pf.parse()
        // this.coords.worker$.parser.directPost({
        //     action: "parse-text",
        //     payload: {
        //         connectionId: this.connection.id,
        //         text: this.text$.getValue()
        //     }
        // })
    }


    async refreshClipboard() {
        // this.coords.databin$.communicatorUnconfirmedLs = []
        const txt = await navigator.clipboard.readText()
        this.text$.next(txt)
    }

    async clearClipboard() {
        // this.coords.databin$.communicatorUnconfirmedLs = []
        await navigator.clipboard.writeText("")
        this.text$.next("")
        this.connection.refreshMessageWidget("info", "msg_clipboardCleared")
    }

    step2Next() {
        // this.connection.readParserList(this.coords.databin$.communicatorPreviewLs)
        this.coords.databin$.communicatorStage$.next(3)
    }

    get dialogTitle() {
        return this.coords.text("Clipboard")
    }

    get info() {
        const txt = this.text$.getValue()!

        return {
            hits: this.connection.get('_hits')
        }

    }

    get size() {
        return this.connection.size
        // if (this.coords.databin$.communicatorStage$.getValue() === 4)
        //     return this.connection.size
        // return this.coords.databin$.communicatorPreviewLs.length
    }

    async confirm(payload?: any) {
        if (this.connection.inProject && payload) {
            this.connection.set("title", payload.title)
            this.connection.set("description", payload.description)
        } else
            this.connection.finalize()
        this.coords.databin$.communicatorStage$.next(0)
    }
    // const bLs: any[] = [{
    //     title: "Close",
    //     fun: () => this.coords.display$.closeDialog()
    // },
    // {
    //     title: "RefreshClipboard",
    //     isPrimary: !this.coords.databin$.communicatorPreviewLs$.getValue().length,
    //     fun: () => this.parseClipboard()
    // }]



    // if (!!this.coords.databin$.communicatorPreviewLs$.getValue().length)
    //     bLs.push({
    //         title: "createConnection",
    //         isPrimary: true,
    //         fun: () =>
    //             this.coords.databin$.confirmConnection(
    //                 this.connection, 
    //                 this.coords.databin$.communicatorPreviewLs$.getValue(),
    //                 `${this.connection.connector.tag}`
    //             )
    //     })

    // return {
    //     bLs: bLs
    // }
    // }
}
